import React from "react";
import ButtonBase from "./Buttons";

const StatusCheckCard = ({
  title,
  subtitle,
  description,
  actionLabel,
  onAction,
  actionVariant = "danger",
  className = "",
}) => {
  return (
    <div className={`ui-status-card ${className}`.trim()}>
      {title ? <h2 className="ui-status-card__title">{title}</h2> : null}
      {subtitle ? <p className="ui-status-card__subtitle">{subtitle}</p> : null}

      <div className="ui-status-card__icon-wrap">
        <img src="/check.png" alt="Success" className="ui-status-card__icon" />
      </div>

      {description ? <div className="ui-status-card__description">{description}</div> : null}

      {actionLabel ? (
        <ButtonBase onClick={onAction} variant={actionVariant} className="ui-status-card__action-btn" size="lg">
          {actionLabel}
        </ButtonBase>
      ) : null}
    </div>
  );
};

export default StatusCheckCard;
